import { apiClient } from './axiosInstance';
import {
  IDeleteRateHistoryEntryData,
  IMemberInfoUpdatingData,
  UpdateRateHistoryEntryData,
} from 'features/memberInfo/memberInfoTypes';

export const fetchOrganizationMemberInfo = async (memberId: number) => {
  return await apiClient.get(`/members/${memberId}`);
};

export const updateMemberInfo = async (data: IMemberInfoUpdatingData) => {
  return await apiClient.patch(`/members/${data.id}`, {
    ...data,
  });
};

export const addPayRateHistoryEntry = async (data: {
  memberId: number;
  payload: UpdateRateHistoryEntryData;
}) => {
  if (data.payload.paymentRateType === 'billRate') {
    return await apiClient.post(`/pay-amounts/bill-rate/${data.memberId}`, {
      rate: data.payload.rate,
      startDate: data.payload.startDate,
    });
  } else {
    return await apiClient.post(`/pay-amounts/pay-rate/${data.memberId}`, {
      rate: data.payload.rate,
      payType: data.payload.type,
      startDate: data.payload.startDate,
    });
  }
};

export const updatePayRateHistoryEntry = async (data: {
  payload: UpdateRateHistoryEntryData;
}) => {
  if (data.payload.paymentRateType === 'billRate') {
    return await apiClient.patch(`/pay-amounts/bill-rate/${data.payload.id}`, {
      rate: data.payload.rate,
      startDate: data.payload.startDate,
    });
  } else {
    return await apiClient.patch(`/pay-amounts/pay-rate/${data.payload.id}`, {
      rate: data.payload.rate,
      payType: data.payload.type,
      startDate: data.payload.startDate,
    });
  }
};

export const deletePayRateHistoryEntry = async (
  data: IDeleteRateHistoryEntryData
) => {
  return await apiClient.delete(
    `/pay-amounts/${data.payAmountType}/${data.entryId}`
  );
};
